import { render, staticRenderFns } from "./KmtcCouponGiftPop.vue?vue&type=template&id=6351c6f3&scoped=true"
import script from "./KmtcCouponGiftPop.vue?vue&type=script&lang=js"
export * from "./KmtcCouponGiftPop.vue?vue&type=script&lang=js"
import style0 from "./KmtcCouponGiftPop.vue?vue&type=style&index=0&id=6351c6f3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6351c6f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6351c6f3')) {
      api.createRecord('6351c6f3', component.options)
    } else {
      api.reload('6351c6f3', component.options)
    }
    module.hot.accept("./KmtcCouponGiftPop.vue?vue&type=template&id=6351c6f3&scoped=true", function () {
      api.rerender('6351c6f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/schedule/popup/KmtcCouponGiftPop.vue"
export default component.exports